import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const MotorIncluded = ({ motorIncluded }: SpecProps<"motor_included">) => {
  const { i18n } = useLingui();

  if (typeof motorIncluded !== "boolean") {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.motor_included",
    message: "Motor included",
    comment: "Field for 'motor included' in ad specification",
  });
  return <FieldValuePair field={field} value={motorIncluded} />;
};
